import Selector from "./Selector"
import SelectorTrigger from "./SelectorTrigger"
import SelectorSearch from "./SelectorSearch"
import SelectorContent from "./SelectorContent"
import SelectorList from "./SelectorList"
import SelectorItem from "./SelectorItem"
import SelectorItemText from "./SelectorItemText"
import SelectorDialog from "./SelectorDialog"
import SelectorFooter from "./SelectorFooter"
import SelectorHeading from "./SelectorHeading"

export type { SelectorTriggerProps } from "./SelectorTrigger"
export type { SelectorItemProps } from "./SelectorItem"
export type { SelectorContentProps } from "./SelectorContent"
export type { SelectorListProps } from "./SelectorList"
export type { SelectorSearchProps } from "./SelectorSearch"
export type { SelectorDialogProps } from "./SelectorDialog"
export type { SelectorFooterProps } from "./SelectorFooter"
export type { SelectorHeadingProps } from "./SelectorHeading"

export default Object.assign(Selector, {
  Trigger: SelectorTrigger,
  Search: SelectorSearch,
  Content: SelectorContent,
  List: SelectorList,
  Item: SelectorItem,
  ItemText: SelectorItemText,
  Dialog: SelectorDialog,
  Footer: SelectorFooter,
  Heading: SelectorHeading,
})
